// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"623763ab","189":"a34e0510","207":"1e0fd45e","328":"afb1d611","421":"581ca51d","453":"c3e71834","689":"45d871f5","691":"a7bd7447","692":"d02a24f6","787":"69c5fbc5","800":"8251d65f","824":"cb1ad730","999":"55a69121"}[chunkId] + ".chunk.js";
};